import React from "react";

const Checkbox = ({
  label,
  labelComponent,
  labelClassName = "",
  checked = false,
  disabled = false,
  onChange = () => {},
  boost = false,
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={`checkmarkContainer my-1${labelClassName ? ` ${labelClassName}` : ""}`}>
      {labelComponent || label}
      <input
        data-testid="Checkbox-testSelector"
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className={`checkmark${boost ? " checkmark-boost" : ""}`} />
    </label>
  );
};

export default Checkbox;
